export default {
  BLACK_LIST_USER_LIST: "Liste noire",
  ADD_BLACK_LIST_USER: "Ajouter un utilisateur en liste noire",
  EDIT_BLACK_LIST_USER: "Modifier un utilisateur en liste noire",
  BLACK_LIST_USER_ADDED: "L'utilisateur est ajouté en liste noire",
  DELETE_THIS_BLACK_LIST_USER: "Supprimer cet utilisateur de la liste noire ?",
  BLACK_LIST_USER_DELETED: "L'utilisateur est supprimée de la liste noire",
  EXCERPT: "Note",
  VIEW_BLACK_LIST_USER: "Liste noire",
};
